var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dg-dict-tree" },
    [
      _c("dg-tree", {
        ref: "tree",
        attrs: {
          "api-code": "sysDictTree",
          root: _vm.dimCode,
          "node-key": "ROWCODE",
          "pnode-key": "PARENTCODE",
          label: "ROWNAME",
          "show-screen": true,
          "default-expand-all": false,
          "expand-on-click-node": false,
          placeholder: "输入关键字进行过滤",
          "node-buttons": _vm.nodeButtons,
          "tree-list-data": _vm.data,
        },
        on: {
          "update:treeListData": function ($event) {
            _vm.data = $event
          },
          "update:tree-list-data": function ($event) {
            _vm.data = $event
          },
          click: _vm.handleNodeClick,
        },
      }),
      _vm._v(" "),
      _vm.showAdd
        ? _c("el-button", {
            staticClass: "topic-add",
            attrs: { icon: "el-icon-plus" },
            on: {
              click: function ($event) {
                return _vm.showFormDrawer("insert")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "dg-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleFormSubmit,
          },
        },
        [
          _c("dg-form", {
            ref: "form",
            attrs: {
              "form-data": _vm.form,
              "form-items": _vm.formItems,
              rules: _vm.formRules,
              "label-position": "top",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }